<template>
  <div class="pt20">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-1">
            <div
              class="number-circle lh35 cl-white brdr-circle align-center weight-700"
              :class="{ 'bg-cl-th-accent' : isActive, 'bg-cl-tertiary' : !isActive }"
            >
              3
            </div>
          </div>
          <div class="col-xs-8 col-sm-8 col-md-10">
            <div class="row">
              <div class="col-xs-12" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
                <h3 class="m0">
                  {{ $t('Courier pickup address') }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-1 end-xs">
            <i data-v-0c2f6ec6="" class="material-icons arrow-i"
               :class="{ 'active' : isActive }"
            >keyboard_arrow_right</i>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt15" v-if="isActive">
      <div class="col-xs-12">
        <address-form @updated="pickupAddressUpdated" :other-receiver="false" :stored-address="pickupAddress" />
      </div>
    </div>
    <div class="row " v-if="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-md-8 my15" style="margin: auto">
            <button-full
              data-testid="pickupAddressSubmit"
              @click.native="sendDataToCheckout"
              :disabled="$v.pickupAddress.$invalid"
            >
              {{ $t('Continue to delivery address') }}
            </button-full>
          </div>
        </div>
      </div>
    </div>
    <div class="row " v-if="!isActive && isFilled">
      <div class="col-xs-12">
        <div class="row fs16 brdr-bottom-1 brdr-cl-bg-secondary">
          <div class="col-xs-12">
            <div class="lh30 flex end-xs" v-if="!isActive && isFilled">
              <a href="#" class="cl-tertiary flex" @click.prevent="edit">
                <span class="pr5 h6">
                  {{ $t('Edit') }}
                </span>
                <i class="material-icons cl-tertiary">edit</i>
              </a>
            </div>
          </div>
          <div class="col-xs-12 h4 mb15 bg-cl-secondary" data-testid="pickupAddressSummary">
            <p>
              {{ assembleAddress }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ButtonFull from 'theme/components/theme/ButtonFull'
import AddressForm from 'theme/components/core/blocks/Form/Customer/Shipping/AddressForm'

export default {
  components: {
    ButtonFull,
    AddressForm
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isFilled: false,
      pickupAddress: {
        street: '',
        house: '',
        apartment: '',
        city: '',
        state: '',
        country: '',
        postcode: '',
        longitude: '',
        latitude: '',
        api_details: '',
        comment: ''
      }
    }
  },
  methods: {
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('pickup-checkout-before-edit', 'pickupAddress')
      }
    },
    pickupAddressUpdated (address) {
      if (!address) return
      this.pickupAddress = { ...this.pickupAddress, ...address }
    },
    sendDataToCheckout () {
      if (!this.pickupAddress.longitude || !this.pickupAddress.latitude || !this.pickupAddress.api_details) {
        this.$bus.$emit('scroll-to-the-address-form')
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Address is not valid!'),
          action1: { label: this.$t('OK') }
        })
        return
      }
      this.$bus.$emit('pickup-checkout-after-pickupAddress', this.pickupAddress, this.$v)
      this.isFilled = true
    }
  },
  computed: {
    assembleAddress () {
      let address = `${this.pickupAddress.street}, ${this.pickupAddress.house}`
      if (this.pickupAddress.apartment) {
        address += `, ${this.$t('кв. ')}${this.pickupAddress.apartment}`
      }
      return address
    }
  },
  validations: {
    pickupAddress: {
      street: {
        required
      },
      house: {
        required
      }
    }
  }
}
</script>
